import { Grid, Container } from '@mui/material'
import ServiceCard from '../ServiceCard'
import { useState } from 'react'

// Icons
import ForestIcon from '@mui/icons-material/Forest'
import DevicesIcon from '@mui/icons-material/Devices'
import BugReportIcon from '@mui/icons-material/BugReport'
import ParkIcon from '@mui/icons-material/Park'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import GroupsIcon from '@mui/icons-material/Groups'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const services = [
  {
    title: 'Gestión Forestal Urbana',
    description:
      'Gestionamos técnicamente el arbolado de tu ciudad mediante inventarios georreferenciados, monitoreo continuo y valoración económica en dólares de cada árbol individual, con asesoría especializada en la normativa ecuatoriana vigente.',
    icon: <ParkIcon fontSize="large" />,
    color: '#92a249',
    items: [
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Inventario forestal urbano georreferenciado' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Monitoreo forestal continuo del arbolado' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Valoración económica automatizada (USD por árbol)' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Arquitectura y paisajismo urbano' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Asesoría en ordenanzas y normativa de arbolado urbano' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Cumplimiento normativo: registro en SUIA y Acuerdo Ministerial 059' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Selección de especies óptimas para arbolado urbano' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Guía de especies recomendadas por ciudad o región climática' },
    ],
  },
  {
    title: 'Innovación Tecnológica',
    description:
      'Desarrollamos tecnología de vanguardia para visualizar tu arbolado urbano en tres dimensiones con modelos propios de especies nativas, generar reportes temáticos con mapas SIG e identificar árboles desde fotografía aérea mediante Inteligencia Artificial.',
    icon: <DevicesIcon fontSize="large" />,
    color: '#0c2342',
    items: [
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Plataforma web pública ArbolEc con visualizador 3D' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Mapas temáticos SIG y reportes especializados' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Conteo automático de árboles con Inteligencia Artificial desde fotografía aérea' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Modelos 3D propios de especies arbóreas del Ecuador' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Paleta de colores reales de especies para uso arquitectónico' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Etiquetado físico con código QR para consulta web' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Módulo "espejo" para municipios: integración del visualizador en el sitio web del GAD' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Reportes técnicos automatizados y exports de datos' },
    ],
  },
  {
    title: 'Estado Fitosanitario',
    description:
      'Inspeccionamos y monitoreamos la salud del arbolado urbano para identificar plagas, enfermedades y vulnerabilidades por especie. Generamos rankings de adaptación y guías prácticas de poda y cuidado para mantener un patrimonio arbóreo saludable.',
    icon: <BugReportIcon fontSize="large" />,
    color: '#4E6A5B',
    items: [
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Identificación de plagas y enfermedades por inspección visual' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Análisis en campo y laboratorio' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Planificación sanitaria del arbolado' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Ranking de especies más vulnerables y más resistentes' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Detección temprana de plagas y enfermedades emergentes' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Guía de poda y cuidado del arbolado por especie y condición' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Recomendaciones de manejo personalizadas por árbol' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Identificación de árboles alergógenos en el inventario urbano' },
    ],
  },
  {
    title: 'Servicios Ecosistémicos',
    description:
      'Cuantificamos automáticamente los beneficios ambientales que el arbolado urbano aporta a tu ciudad: carbono almacenado, biomasa, oxígeno producido, hábitat para fauna urbana e índice verde por barrio, parroquia o sector.',
    icon: <ForestIcon fontSize="large" />,
    color: '#93c032',
    items: [
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Cuantificación automatizada de almacenamiento de carbono' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Cuantificación de biomasa aérea' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Estimación de producción de oxígeno' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Evaluación de árboles óptimos como hábitat para fauna urbana' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Belleza escénica y valor paisajístico' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Índice verde urbano por barrio, parroquia o ciudad' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Reporte agregado de servicios ecosistémicos para memorias y reportes ESG' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Análisis comparativo entre especies (nativas, exóticas, sitios)' },
    ],
  },
  {
    title: 'Análisis y Gestión de Riesgos',
    description:
      'Evaluamos automáticamente el nivel de riesgo de cada árbol mediante nuestro sistema propio en formato semáforo (Bajo, Medio, Alto), priorizamos intervenciones y realizamos peritajes técnicos especializados para árboles críticos y situaciones de emergencia.',
    icon: <WarningAmberIcon fontSize="large" />,
    color: '#c0392b',
    items: [
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Evaluación automatizada de riesgo (semáforo ArbolEc)' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Mapa dinámico de riesgo del arbolado urbano' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Plan de priorización de intervenciones (derribo, poda, monitoreo)' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Frecuencias de inspección por clase de riesgo' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Evaluación de riesgo según metodología internacional ISA TRAQ' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Peritajes técnicos en árboles de alto riesgo' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Estudios complementarios con instrumentación avanzada' },
    ],
  },
  {
    title: 'Educación y Participación Ciudadana',
    description:
      'Fortalecemos la apropiación ciudadana del arbolado urbano mediante programas de apadrinamiento de árboles, divulgación digital sobre las especies de la ciudad, material educativo y comunicación estratégica para crisis y eventos críticos.',
    icon: <GroupsIcon fontSize="large" />,
    color: '#1F4E79',
    items: [
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Programa de apadrinamiento de árboles para empresas y ciudadanos' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Comunicación estratégica para crisis de arbolado urbano' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Educación ambiental y divulgación digital en redes sociales' },
      { icon: <CheckCircleIcon fontSize="small" />, text: 'Material informativo del arbolado urbano local (boletines, fichas, infografías)' },
    ],
  },
]

const ServiceComponent = () => {
  const [activeCards, setActiveCards] = useState(() => new Set())

  const handleToggle = index => {
    setActiveCards(prev => {
      const next = new Set(prev)
      if (next.has(index)) {
        next.delete(index)
      } else {
        next.add(index)
      }
      return next
    })
  }

  return (
    <Container
      maxWidth={false}
      sx={{ mt: 4, pb: 6, borderRadius: 4 }}>
      <Grid
        container
        spacing={4}
        alignItems="stretch"
        px={{ xs: 2, sm: 3, md: 6, lg: 10, xl: 12 }}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
            <ServiceCard
              {...service}
              expanded={activeCards.has(index)}
              onToggle={() => handleToggle(index)}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}

export default ServiceComponent
